import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countrySelect", "citySelect"]
  static values = { cities: Object, currentCity: Number }

  connect() {
    this.populateCities()
    if (this.currentCityValue) {
      this.citySelectTarget.value = this.currentCityValue
    }
  }

  onCountryChange() {
    this.citySelectTarget.value = ""
    this.populateCities()
  }

  populateCities() {
    const country = this.countrySelectTarget.value
    const cities = this.citiesValue[country] || []

    const prompt = this.citySelectTarget.querySelector('option[value=""]')
    this.citySelectTarget.innerHTML = ""

    if (prompt) {
      this.citySelectTarget.appendChild(prompt)
    }

    cities.forEach((city) => {
      const option = document.createElement("option")
      option.value = city.id
      option.textContent = city.name
      this.citySelectTarget.appendChild(option)
    })
  }
}
